// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.shared.common.BusinessPhonesResponse */
/* istanbul ignore next */
@GandalfModel
export class BusinessPhonesResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	altPhone!: string | null;

	@GandalfProperty({ designType: String })
	emergencyPhone!: string | null;

	@GandalfProperty({ designType: String })
	fax!: string | null;

	@GandalfProperty({ designType: String })
	mainPhone!: string | null;

	@GandalfProperty({ designType: String })
	tollFree!: string | null;

}
